<template>
  <div :id="'map' + mapId" class="map-div"></div>
</template>

<script>
import * as _ from "lodash";

const L = require("leaflet");

//https://github.com/pointhi/leaflet-color-markers
const redIcon = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export default {
  data() {
    return {
      // HN 500 N 3rd St
      map: null,
      baseLat: 33.453603,
      baseLon: -112.070089,
      maxZoom: 18,
      markers: []
    };
  },

  props: {
    // if displaying several maps on page, each must have unique ID
    mapId: {
      type: String,
      required: false
    },
    items: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    itemRoute: {
      type: String,
      required: false,
    },
    itemKey: {
      type: String,
      required: false
    },
    zoom: {
      type: Number,
      required: false,
      default: 13
    }
  },

  computed: {
    siteUrl: function() {
      return process.env.NODE_ENV !== "production"
        ? "https://communitypartnerships-dev.chs.asu.edu/" + (this.itemRoute ? this.itemRoute + "/" : "")
        : "https://communitypartnerships.chs.asu.edu/" + (this.itemRoute ? this.itemRoute + "/" : "");
    }
  },

  methods: {
    createMap() {
      this.$nextTick().then(() => {
        this.map = L.map("map" + this.mapId).setView(
          [this.baseLat, this.baseLon],
          this.zoom
        );

        // tile layer
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);

        L.marker([this.baseLat, this.baseLon], { icon: redIcon })
          .addTo(this.map)
          .bindPopup("<b>College of Health Solutions</b>")
          .openPopup();
      });
    }
  },
  watch: {
    items: function() {
      _.forEach(this.markers, marker => {
        this.map.removeLayer(marker);
      });
      if (this.items.length) {
        _.forEach(this.items, item => {
          if (item.lat && item.lon) {
            var addressString =
              item.address +
              ", " +
              item.city +
              ", " +
              item.state +
              ", " +
              item.zip;
            var marker = L.marker([item.lat, item.lon]);
            this.markers.push(marker);

            if(this.itemRoute && this.itemKey) {
              marker
              .addTo(this.map)
              .bindPopup("<b><a href=" + this.siteUrl + item[this.itemKey] + ">" + item.name + "</a></b><br/>" + addressString);
            }
            else {
              marker
              .addTo(this.map)
              .bindPopup("<b>"+ item.name + "</b><br/>" + addressString);
            }
            
          }
        });
      }
    }
  },
  created: function() {
    this.createMap();
  }
};
</script>

<style scoped>
.map-div {
  height: 700px;
}
.map-not-found {
  font-style: italic;
}
</style>
